"use strict";

(function () {
  'use strict';

  angular.module('lr.SideNav', ['lr.SideNav.directives']).run(['$rootScope', '$location', function ($rootScope, $location) {
    $rootScope.$on('$routeChangeStart', function () {});
    $rootScope.$on('$routeChangeSuccess', function (event, currentRoute, previousRoute) {
      $rootScope.$broadcast('toggle-app-close');
    });
  }]);
})();